export default "__VITE_ASSET__CVgKc5fI__"